import React from 'react'
import resourceArrowSvg from '../../static/images/resource_arrow.svg'
import '../../styles/ResourceSection/ResourceCards.scss'

const ResourceArrow = () => {
  return (
    <span className="resource_arrow">
      <img
          src={resourceArrowSvg}
          alt="arrow"
      />
    </span>
  )
}

export default ResourceArrow
